import React, { PropsWithChildren } from 'react';

import { DistanceFormattingContext } from '@paragon/material';

import { getDistanceFormatterSelector } from '../../store/selectors/getDistanceFormatterSelector';
import { useAppSelector } from '../hooks';

export function DesignClientDistanceFormattingContext(props: PropsWithChildren) {
  const distanceFormatter = useAppSelector(getDistanceFormatterSelector);
  return <DistanceFormattingContext formatLength={distanceFormatter}>{props.children}</DistanceFormattingContext>;
}
